import { IEnvironmentConfiguration } from './environment';

export const environmentConfiguration: IEnvironmentConfiguration = {
	apiBasePath: 'http://localhost:5002',
	isProduction: false,
	frontendIdentityUrl: 'https://identity-service-ui-dev.peakplatform.io',
	backendIdentityUrl: 'https://identity-service-api-dev.peakplatform.io',
	allowedEmailDomains: ['ascentgl.net']
};
